var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8663 2.97925L10.3171 7.49914L14.8663 12.019C14.9486 11.8471 14.9985 11.6571 14.9985 11.4542V3.54406C14.9985 3.34112 14.9486 3.15113 14.8663 2.97925Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6793 2.22656H1.31604C1.1131 2.22656 0.923105 2.27646 0.751221 2.35869L6.56557 8.14374C7.07967 8.65784 7.91568 8.65784 8.42979 8.14374L14.2441 2.35869C14.0722 2.27646 13.8823 2.22656 13.6793 2.22656Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.132129 2.97925C0.0498926 3.15113 0 3.34112 0 3.54406V11.4542C0 11.6572 0.0498926 11.8472 0.132129 12.019L4.68132 7.49914L0.132129 2.97925Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69494 8.12183L9.0512 8.76557C8.19459 9.62218 6.80073 9.62218 5.94412 8.76557L5.30041 8.12183L0.751221 12.6417C0.923105 12.724 1.1131 12.7738 1.31604 12.7738H13.6793C13.8823 12.7738 14.0722 12.724 14.2441 12.6417L9.69494 8.12183Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.703dbc1f9fafab4063463ad0e87f4e84.svg";
export { ForwardRef as ReactComponent };